export const marginTop = () => ({
  marginTop: `4vh`,
})

export const marginRight = () => ({
  marginRight: `1em`,
})
